export enum SortTasksKanbanBy {
  Deadline = 'deadline',
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at',
}

export enum SortTasksKanbanDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

